import { styled } from '@mui/material/styles';

export const Container = styled('div')(({ theme }) => ({
  width: '100%',
  position: 'relative',
  borderBottom: `1px solid ${theme.palette.action.disabledBackground}`,
  padding: `${theme.spacing(2)} 0`,
}));

export const LeftIcon = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 10,
  left: 0,
  width: 40,
  height: 40,
  borderRadius: 40,
  backgroundColor: theme.palette.action.disabled,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.common.white,
}));

export const TextContainer = styled('div')({
  width: 'calc(100% - 50px)',
  marginLeft: 50,
});

export const DateRow = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  fontSize: 12,
  marginBottom: theme.spacing(1),
  fontStyle: 'italic',
}));

export const Date = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(3),
}));

export const CorrectionContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(1),
  fontSize: 13,
}));

export const ChangeContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  fontSize: 14,
}));

export const Bold = styled('span')({
  fontWeight: 'bold',
});

export const CommentText = styled('div')({
  fontSize: 14,
});

export const Author = styled('div')(({ theme }) => ({
  marginRight: theme.spacing(2),
}));

export const ImagesContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  position: 'relative',
  marginTop: theme.spacing(1),
}));

export const WhiteIcon = styled('div')(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const SignatureContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  borderTop: `1px dashed ${theme.palette.action.disabledBackground}`,
  paddingTop: theme.spacing(1),
}));

export const SignatureItem = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const SignatureImage = styled('img')(({ theme }) => ({
  height: 50,
  border: `1px solid ${theme.palette.action.disabledBackground}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
}));

export const SignatureTimestamp = styled('span')(({ theme }) => ({
  fontSize: 12,
  color: theme.palette.text.secondary,
  fontStyle: 'italic',
}));

export const FilesContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  marginTop: theme.spacing(1),
}));
